export default __webpack_public_path__ + "assets/11.4568a0ed.png";